// NhanXetInput.tsx
import React, { useState, useEffect } from 'react';
import { Textarea } from '@primer/react';

interface NhanXetInputProps {
  value: string;
  onSave: (value: string) => void;
  disabled?: boolean;
}

const NhanXetInput: React.FC<NhanXetInputProps> = ({ 
  value, 
  onSave, 
  disabled 
}) => {
  const [localValue, setLocalValue] = useState(value || '');

  // Update localValue when value prop changes
  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  return (
    <Textarea
      value={localValue}
      onChange={(e) => {
        setLocalValue(e.target.value);
      }}
      onBlur={() => {
        if (localValue !== value) {
          onSave(localValue);
        }
      }}
      rows={2}
      sx={{ 
        width: '100%',
        resize: 'vertical',
        minHeight: '60px'
      }}
      disabled={disabled}
    />
  );
};

export default NhanXetInput;